<template>
  <div class="app-container">
    <navigation title="国图文创"></navigation>
    <div class="content">
      <van-tabs title-inactive-color="#333" line-width="30px" line-height="2px" @click="tabClick">
        <van-tab v-for="item in tabClass" :title="item" :name="item">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="shop-content">
              <dl class="shop" v-for="item in list" @click="goCultural(item.link)">
                <dt class="shop-img"><img :src="item.coverPath" alt=""></dt>
                <dd>{{ item.title }}</dd>
              </dl>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
    <version></version>
    <scroll></scroll>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import scroll from '../../components/scroll'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'cultural',
  components: {navigation, version, scroll},
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      checked: false,
      choose: true,
      checkAll: false,
      ifManagement: true,
      prompt: '',
      tabClass: ['全部'],
      params: {
        pageNum: '1',
        pageSize: '10'
      }
    }
  },
  created () {
    // tab分类
    this.getTab()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onLoad () {
      request('get', '/nlc-web/api/cultural', this.params).then(res => {
        console.log('文创列表', res)
        for (var i = 0; i < res.data.content.length; i++) {
          this.list.push(res.data.content[i])
        }
        // 加载状态结束
        this.loading = false
        if (res.data.totalElements === this.list.length) {
          this.finished = true
        }
      })
      this.params.pageNum++
    },
    getTab () {
      request('get', '/nlc-web/api/cultural/type').then(res => {
        console.log('文创分类', res)
        res.data.sort(function(a,b){
          let order = ['典藏','学习','生活'];
          return order.indexOf(a) - order.indexOf(b);
        })
        let result = res.data.map(function(a){
          return a;
        })
        console.log('result',result)
        for (var i = 0; i < result.length; i++) {
          this.tabClass.push(result[i])
        }
      })
    },
    tabClick (name) {
      console.log('name', name)
      this.params.pageNum = '1'
      this.list = []
      this.loading = true
      this.finished = false
      if (name === '全部') {
        delete this.params.type
        this.onLoad()
      } else {
        this.params.type = '' + name + ''
        this.onLoad(name)
      }
    },
    // 去文创详情页
    goCultural (link) {
      window.location.href = link
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'culturalDetail') {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();//不可缺少
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  min-height:100%;
  padding-top:.92rem;
}
.content{
  width: 6.94rem;
  margin:.26rem .28rem .16rem .28rem;
  border-radius:8px;
  background:#fff;
  padding:.1rem 0;
}
.shop-content{
  width:6.94rem;
  overflow:hidden;
  display: flex;
  flex-wrap:wrap;
}
.shop{
  width:1.96rem;
  color:#333;
  font-size:.28rem;
  text-align:center;
  margin: .1rem 0 0 .28rem;
}
.shop-img img{
  width:1.96rem;
  height:1.96rem;
  border-radius:8px;
}
.shop dd{
  margin:0;
  padding-top:.11rem;
  color:#333;
  /*overflow: hidden;*/
  /*text-overflow:ellipsis;*/
  /*white-space: nowrap;*/
  font-family: SourceHanSerifCN-Regular;
}
>>>.van-tab__text--ellipsis{
  font-family: SourceHanSerifCN-SemiBold;
}
>>>.van-tab--active{
  font-size:.36rem;
  line-height:.4rem;
}
>>>.van-tabs__wrap{
  height:.65rem;
}
>>>.van-tab--active .van-tab__text--ellipsis{
  font-size:.32rem;
  line-height: .32rem;
}
>>>.van-tab__text--ellipsis{
  font-size:.28rem;
  line-height: .32rem;
  font-family: SourceHanSerifCN-Regular
}
</style>



// WEBPACK FOOTER //
// src/view/cultural/index.vue